export default __webpack_public_path__ + "static/media/Litecoin.1fd1f1a5.svg";